/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SlideoutDOM
 * @hideconstructor
 * @classdesc API class that is used to manage Slideout functionality
 * (including the corrsponding view) across API calls
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'underscore',
	'./PropertiesPaneDOMAPI'
], function(APIFactory, _, PropertiesPaneDOMAPI) {

	class PropertiesPaneDOM {

		constructor({ features }) {
			this._dashboard = features.API;
			this._properties = features.PropertiesPane;
			this._slideout = features.InAppSlideoutDOM;
			this._api = null;

			this._initialize();
		}

		getAPI() {
			return this._api;
		}

		isEnabled() {
			const featureChecker = this._dashboard.getGlassCoreSvc('.FeatureChecker');
			return !featureChecker || !featureChecker.checkValue('dashboard', 'PropertiesV2', 'enabled');
		}

		getProviderId() {
			return this._properties.getProviderId();
		}

		_initialize() {
			this._api = APIFactory.createAPI(this, [PropertiesPaneDOMAPI]);
			if (this.isEnabled()) {
				this._slideout.registerView(this._properties.getProviderId(), this._api);
			}
		}

		getPropertiesView(options = {}) {
			this._renderNode = options.parentNode;
			let viewRenderedPromise;
			const propertiesManager = this._dashboard.getFeature('propertiesManager');
			if(options.isChild){
				viewRenderedPromise = propertiesManager.updateChildPropertiesView(options);
			}  else {
				const selectedContentIds = this._getSelectedContentIds();
				let contentId;
				if (selectedContentIds && selectedContentIds.length > 0) {
					contentId = selectedContentIds[0];
				}
				viewRenderedPromise = propertiesManager.getPropertiesView(contentId);
			}
			return viewRenderedPromise;
		}

		_getSelectedContentIds() {
			return this._dashboard.getCanvas().getSelectedContentList().map(content => content.getId());
		}

		getRenderNode(){
			return this._renderNode;
		}

		render(theOptions) {
			const propertiesManager = this._dashboard.getFeature('propertiesManager');
			const options = propertiesManager.getMostRecentChildOptions(theOptions);
			return this.getPropertiesView(options)
				.then((view) => {
					if (options && options.childPanelId) {
						view.$el.get(0).dataset.childPanelId = options.childPanelId;
					}
					return view.$el.get(0);
				});
		}

		close() {
			const propertiesManager = this._dashboard.getFeature('propertiesManager');
			if (propertiesManager) {
				propertiesManager.closeAllChild();
			}

			this._renderNode = null;
		}

		destroy() {
			this.close();
			this._api = null;
			this._dashboard = null;
			this._properties = null;
			this._slideout = null;
		}
	}

	return PropertiesPaneDOM;
});
